/**
 * viewPort values:
 *
 * extraSmall: (...)
 * small: (...)
 * medium: (...)
 * large: (...)
 * extraLarge: (...)
 */

export default {
  data() {
    return {
      rows: 4,
      gridSpace: 12,
      breakpoints: {
        xs: 'extraSmall',
        sm: 'small',
        md: 'medium',
        lg: 'large',
        xl: 'extraLarge'
      },
    };
  },
  methods: {
    showVideoDetails(settings) {
      const breakPoint = settings.viewportGridBreakpointsProperties || null;
      if (_.has(breakPoint, 'small')) {
         /*
          .col-xs-$	Extra Small	Phones Less than 768px
          .col-sm-$	Small Devices	Tablets 768px and Up
          .col-md-$	Medium Devices	Desktops 992px and Up
          .col-lg-$	Large Devices	Large Desktops 1200px and Up
        */
        const mobileVisibility = breakPoint.extraSmall.fields.title
          ? 'd-block'
          : 'd-none';

        const ipadVisibility = breakPoint.small.fields.title
          ? 'd-sm-block'
          : 'd-sm-none';

        const desktopVisibility = breakPoint.large.fields.title
          ? 'd-lg-block'
          : 'd-lg-none';
        
        const extraLargeScreens = breakPoint.extraLarge.fields.title
          ? 'd-xl-block'
          : 'd-xl-none';
        
        return mobileVisibility + ' ' + ipadVisibility + ' ' + desktopVisibility;
      }

      return true;
    },
    // @Todo: Remove this method due to only one template will be in use after droppign the use of bootstrap
    calculateCards(settings = {}) {
      return this.gridMaterial(settings);
    },
    gridMaterial(settings) {
      
      const breakPoint = settings.viewportGridBreakpointsProperties || null;
      const name = this.breakpoints[this.$vuetify.breakpoint.name]
      const cols = this.gridSpace/breakPoint[name].columns
      
      if (_.has(breakPoint, 'small')) {
        
        const mobile = [
          `col-xs-${this.gridSpace/breakPoint.small.columns}`,
          `col-sm-${this.gridSpace/breakPoint.extraSmall.columns}`
        ];
        const ipad = `col-md-${this.gridSpace/breakPoint.small.columns}`;
        const desktop = [
          `col-lg-${this.gridSpace/breakPoint.large.columns}`,
          `col-xl-${this.gridSpace/breakPoint.extraLarge.columns}`
        ];
        
        return `col-${cols} ` + mobile.join(' ') + ' ' + desktop.join(' ') + ' ' + ipad;
      }
      
      //This will remain in case there are elements that does not have
      // the rows values in the settings.
      return 'col-sm-12 col-md-12 col-lg-12 col-xl-12';
    },
    getColumns(settings) {
      const breakPoint = settings.viewportGridBreakpointsProperties || null;
      const name = this.breakpoints[this.$vuetify.breakpoint.name]
      
      if (typeof breakPoint === null) {
        return this.gridSpace
      }
      
      const cols = this.gridSpace/breakPoint[name].columns
      
      return cols
    }
  }
}